module.exports = __webpack_public_path__ + "static/img/cont3605.053ffeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3605.jpg
// module id = 0M3E
// module chunks = 0